import React, {useEffect, useRef, useState} from "react";
import { Transition } from 'react-transition-group';
import CONST from "../../config/CONST";
import FormIframe from "../FormIframe/FormIframe";
import FormLayerHeader from "../FormLayerHeader/FormLayerHeader";
import FormLayerThankyou from "../FormLayerThankyou/FormLayerThankyou";
import GATracker, {GAEventBuildObject} from "../../helpers/GATracker";
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import {logInfo} from "../../helpers/debugLog";


const FormLayer = (props) => {

    const {
        isVisible,
        onFormLayerHeightChange
    } = props;

    const transitionNodeRef = useRef(null);

    const [isThankyou, setIsThankyou] = useState(false);

    const appData = useSelector(getAppData);
    const financialConfiguration = useSelector(getFinancialConfiguration);

    const onIframeHeightChange = () => {
        const h = transitionNodeRef.current.clientHeight;
        onFormLayerHeightChange(h);
    }

    const showThankyou = () => {
        setIsThankyou(true);
    }
    const hideThankyou = () => {
        setIsThankyou(false);
    }




    // handle thank you page
    useEffect(() => {

        if(!appData || !financialConfiguration) {
            return;
        }

        hideThankyou();




        const postMessageHandler = (ev) => {

            if (typeof ev.data !== 'object' || !ev.data.func) {
                return;
            }

            logInfo('postMessage', ev);

            const POST_MESSAGE_ACTIONS = {
                FORM_SUBMIT_OK: 'form_submit_ok',
                FORM_SUBMIT_KO: 'form_submit_ko',
            };

            switch(ev.data.func) {

                case POST_MESSAGE_ACTIONS.FORM_SUBMIT_OK:

                    showThankyou();

                    GATracker.trackEvent(GAEventBuildObject({
                        event: {
                            name: GATracker.EVENTS.LEAD_FORM_RESULT_OK.name,
                            category: GATracker.EVENTS.LEAD_FORM_RESULT_OK.category,
                            action: GATracker.EVENTS.LEAD_FORM_RESULT_OK.action
                        },
                        appData: appData,
                        financialConfiguration: financialConfiguration
                    }));

                    break;

                case POST_MESSAGE_ACTIONS.FORM_SUBMIT_KO:

                    GATracker.trackEvent(GAEventBuildObject({
                        event: {
                            name: GATracker.EVENTS.LEAD_FORM_RESULT_KO.name,
                            category: GATracker.EVENTS.LEAD_FORM_RESULT_KO.category,
                            action: GATracker.EVENTS.LEAD_FORM_RESULT_KO.action
                        },
                        appData: appData,
                        financialConfiguration: financialConfiguration
                    }));

                    break;

                default:
                // do nothing

            }

        }



        // addEventListener
        window.addEventListener('message', postMessageHandler);
        // remove addEventListener
        return () => window.removeEventListener('message', postMessageHandler)

    // eslint-disable-next-line
    }, [appData, financialConfiguration]);

    if(!appData || !financialConfiguration) {
        return null;
    }

    return (

        <Transition nodeRef={transitionNodeRef} in={isVisible} timeout={0}>
            {state => (
                <div ref={transitionNodeRef}
                     className={`${CONST.CSS_NAMESPACE}FormLayer ${CONST.CSS_NAMESPACE}FormLayer-slidein-${state}`}
                >

                    <div className={`${CONST.CSS_NAMESPACE}FormLayer-header-container`}>
                        { isThankyou ? <FormLayerThankyou/> : <FormLayerHeader/> }
                    </div>


                    <div className={`${CONST.CSS_NAMESPACE}FormLayer-form-container`}>
                        {isVisible && <FormIframe onIframeHeightChange={onIframeHeightChange} /> }
                    </div>


                </div>
            )}
        </Transition>


)
}

export default FormLayer;